/**
 * Tracks which pod chat(s) are currently being actively viewed by the user,
 * across the two possible chat surfaces (the floating `PodChatWindow` and the
 * inline `PodsPage` chat tab). A `Set` is used because more than one floating
 * chat window can be open and un-minimized at the same time.
 *
 * `PodChatManager`'s single global `message.created` listener consults this
 * to decide whether an incoming message should bump the unread badge or be
 * treated as already-read, avoiding a race between separate per-component
 * increment/clear dispatches for the same event.
 */
const focusedPodIds = new Set<string>();

export function addFocusedPod(podId: string): void {
  focusedPodIds.add(podId);
}

export function removeFocusedPod(podId: string): void {
  focusedPodIds.delete(podId);
}

export function isPodFocused(podId: string): boolean {
  return focusedPodIds.has(podId);
}
